<template>
    <div component="AppHeader" :popupvisible="getIsAnyPopupVisible" :class="{ wider: $route.meta.widerHeader }">
        <div container="header" type="horizontal">
            <logo :disabled="!getUserTermsAgreed" />
            <app-header-buttons v-if="appHeaderButtonsVisible" />
            <popup :name="'menu'" :visible="getIsMenuPopupOpen" @close="closeMenuPopup">
                <navigation />
            </popup>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Navigation from '@/components/AppHeader/Navigation/Navigation.vue';
import Logo from '@/components/AppHeader/Logo.vue';
import Popup from '@/components/.global/Popup.vue';
import AppHeaderButtons from '@/components/AppHeader/AppHeaderButtons.vue';

export default {
    name: 'AppHeader',

    components: {
        AppHeaderButtons,
        Navigation,
        Logo,
        Popup,
    },

    methods: {
        ...mapActions(['closeMenuPopup', 'openMenuPopup', 'closeAllPopups', 'openAuthPopup']),
    },

    computed: {
        ...mapGetters(['getIsMenuPopupOpen', 'getIsAnyPopupVisible', 'getUserTermsAgreed']),

        appHeaderButtonsVisible() {
            return typeof this.$route.meta.hideHeaderButtons != undefined ? !this.$route.meta.hideHeaderButtons : true;
        },
    },
};
</script>
<style lang="less">
@import '~@variables';

[component='AppHeader'] {
    width: 100%;
    z-index: 100;
    pointer-events: none;
    position: fixed;

    &.wider {
        [container='header'] {
            max-width: 1200px;
            padding: 0 30px;
        }

        .logo {
            margin-left: 8px;
        }
    }

    [container='header'] {
        display: flex;
        pointer-events: none;
        justify-content: space-between;
        height: 50px;
        padding: 0 30px;
        width: 100%;
        max-width: 980px;
        margin: 0 auto;

        @media (max-width: 980px) {
            padding: 0 5px 0 20px;
            height: 40px;
        }
    }

    .logo {
        pointer-events: all;
        z-index: 10;
    }
}

[component='header'].print {
    height: 140px;
    align-items: center;
    color: white;

    .navigation,
    [component='searchbar'] {
        display: none;
    }

    .logo {
        margin-left: 25px;
    }

    .title {
        display: block;
        font-size: 22px;
        font-weight: bold;
    }

    .date {
        display: block;
        font-size: 15px;
        padding-right: 25px;
    }
}
</style>
<docs>
## AppHeader komponent
### Ukážka docs tagu vo .vue.
** Ktorý podporuje MarkDown **
</docs>
